import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, 
  Toolbar,
   useMediaQuery, useTheme } from "@mui/material";

// project import
import navigation from "../../menu-items";
import Breadcrumbs from "../../../src/components/@extended/Breadcrumbs";

// types
import { openDrawer } from "../../../src/store/reducers/menu";
// import HeaderEditor from "./HeaderEditor"; //@todo remove commented once approved
import MainNewDrawer from "./NewDrawer";
import Header from "./Header";
import dashboard from '../../menu-items/dashboard';
import SidebarHeader from '../../bmr/components/layouts/Portal/Sidebar/SidebarHeader';

// // ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const firstSegment = location.pathname.split('/')[1];
  const { drawerOpen } = useSelector((state) => state.menu);
  const role_id = useSelector((state) => state.loginData.role_id);
  const role_slug = useSelector((state) => state.loginData.role_slug);
  const matchesLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));
    const theme = useTheme();
  
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));

  const [open, setOpen] = useState(drawerOpen);

  const handleDrawerToggle = () => {
    let isChild = null;

    for (let item of dashboard.children) {
      if (item?.subChildren) {
        for (let subItem of item.subChildren) {
          if (subItem.id === firstSegment) {
            isChild = subItem;
            break;
          }
        }
      }
    }

    if (isChild) {
      dispatch(
        openDrawer({
          drawerOpen:
            role_slug === 'investigator' && !matchesLg ? false : !drawerOpen,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(openDrawer({ drawerOpen: false }));
  }, []);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
  }, [drawerOpen]);

  const handleMiniDrawerToggle = () => {
    dispatch(
      openDrawer({
        drawerOpen:
          role_slug === 'investigator' && !matchesLg ? false : !drawerOpen,
      })
    );
  };

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      {/* {role_id === 5 ? (
        <HeaderEditor
          open={open}
          handleDrawerToggle={handleDrawerToggle}
        />
      ) : (
        <Header
          open={open}
          handleDrawerToggle={handleMiniDrawerToggle}
        />
      )} */}
      {/* //@todo remove commented once approved */}
        <Header
          open={open}
          handleDrawerToggle={handleMiniDrawerToggle}
        />

      <MainNewDrawer
        open={open}
        handleDrawerToggle={handleDrawerToggle}
      />

      <Box
        component="main"
        sx={{
          maxWidth: "100%",
          width: open
            ? { xs: "100%", lg: "70%", md: "70%" }
            : { xs: "100%", lg: "100%", md: "100%", sm: "100%" },
          flexGrow: 1,
          height: "100vh",
        }}
        onClick={() => dispatch(openDrawer({ drawerOpen: false }))}
      >
        {/* ✅ Sidebar ONLY for role 5 */}
        {role_id === 5 && (
          <SidebarHeader
            open={open}
            handleDrawerToggle={handleDrawerToggle}
            matchDownMD={matchDownMD}
          />
        )}

{/* @info marked toolbar check extra space is added in editor panel. */}
        {role_id !== 5 && (
          <Toolbar />
        )
        }
        <Breadcrumbs navigation={navigation} title />
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;

